/*兑吧*/
const HealthyCoin = r => require.ensure([],() =>r(require('@/views/healthy-coin/')), 'HealthyCoin')
const CreditsExchange = r => require.ensure([],() =>r(require('@/views/healthy-coin/credits-exchange')), 'CreditsExchange')

export default {
  path: '/healthy-coin',
  component: HealthyCoin,
  meta: { title: '发现健康币' },
  redirect: '/healthy-coin/credits-exchange',
  children: [{
    path: 'credits-exchange',
    meta: { title: '发现健康币' },
    component: CreditsExchange
  }]
}



// WEBPACK FOOTER //
// ./src/views/healthy-coin/router.js